// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3-lBI","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1crHk","obliqueLine":"membershipbadge_obliqueLine__3tnUK"};